export const FUND_TRANSFER_STATUS = {
    SUCCESS: 'Success',
    APPROVED: 'Approved',
    FAILED: 'Failed',
    REJECTED: 'Rejected',
    PENDING: 'Pending'
};